/**
 * The blog is served from a subfolder of the shop - https://www.laatulakki.fi/blogi
 * - rather than from its own subdomain, so that the links it earns build the
 * shop's authority instead of a separate host's.
 *
 * Two consequences for this app:
 *
 * 1. Every internal link needs the /blogi prefix. React Router's <Link> gets it
 *    from <BrowserRouter basename>, but this codebase links with plain <a href>
 *    in most places, and those bypass the router entirely - an unprefixed
 *    href="/post/x" would land on the shop's 404. Use blogHref() for them.
 *
 * 2. Sanity's query API is CORS-locked to the origins listed in manage.sanity.io,
 *    and www.laatulakki.fi is not one of them - served from the new origin every
 *    query would fail and the blog would render empty. Rather than depend on that
 *    setting, nginx reverse-proxies the API under the same origin (see
 *    SANITY_API_HOST below and the /blogi/sanity location in nginx-laatulakki.conf),
 *    which removes the cross-origin request instead of permitting it.
 *
 * PUBLIC_URL comes from "homepage" in package.json at build time: "/blogi" for a
 * deployed build, "" under `npm start`, which keeps local development working.
 */
export const BLOG_BASE = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");

/** Prefixes an app-absolute path with the base the blog is mounted at. */
export const blogHref = (path = "/") =>
  `${BLOG_BASE}${path.startsWith("/") ? path : `/${path}`}` || "/";

/**
 * Where @sanity/client should send queries.
 *
 * Under a deployed build this is the same-origin proxy; with no base (local dev,
 * or a build served at the root) it is null, meaning "talk to Sanity directly",
 * which is what the CORS allowlist already permits.
 */
export const SANITY_API_HOST =
  BLOG_BASE && typeof window !== "undefined"
    ? `${window.location.origin}${BLOG_BASE}/sanity`
    : null;

/** Config @sanity/client understands; spread into its options. */
export const sanityHostConfig = SANITY_API_HOST
  ? { apiHost: SANITY_API_HOST, useProjectHostname: false }
  : {};
